import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import NumberSelector from '@components/NumberSelector'

import { NumbersRangeDivider, NumbersRangeTitle, NumbersRangeWrapper, NumbersRangeWrapperInner } from './index.styles'

interface NumberSelectorProps {
  rangeTitle?: string
  minValue?: number
  maxValue?: number
  selectedStartValue?: number
  selectedEndValue?: number
  step?: number
  onChange?: (minSelectedValue: number, maxSelectedValue: number) => void
}
const NumbersRangeSelect = (props: NumberSelectorProps) => {
  const { t } = useTranslation()

  const { rangeTitle, minValue, maxValue, selectedStartValue, selectedEndValue, step, onChange } = props

  const [minSelectedValue, setMinSelectedValue] = useState(selectedStartValue ?? minValue ?? 0)
  const [maxSelectedValue, setMaxSelectedValue] = useState(selectedEndValue ?? maxValue ?? selectedStartValue ?? minValue ?? 0)

  useEffect(() => {
    if (typeof selectedStartValue === 'number') {
      setMinSelectedValue(selectedStartValue)
    }
    if (typeof selectedEndValue === 'number') {
      setMaxSelectedValue(selectedEndValue)
    }
  }, [selectedStartValue, selectedEndValue])

  const handleFromChange = (val: number) => {
    setMinSelectedValue(val)
    if (onChange) {
      onChange(val, maxSelectedValue)
    }
  }
  const handleToChange = (val: number) => {
    setMaxSelectedValue(val)
    if (onChange) {
      onChange(minSelectedValue, val)
    }
  }

  return (
    <NumbersRangeWrapper data-testid="number-range-select">
      {rangeTitle && <NumbersRangeTitle>{rangeTitle}</NumbersRangeTitle>}
      <NumbersRangeWrapperInner>
        <NumberSelector
          selectorLabel={t(translationKeys.SEARCH_FILTER_BY_DATE_FROM) as keyof typeof translationKeys}
          minValue={minValue}
          maxValue={maxSelectedValue}
          step={step}
          currentValue={minSelectedValue}
          handleValueChange={handleFromChange}
          data-testid="number-range-select-min"
        />
        <NumbersRangeDivider orientation="vertical" variant="middle" flexItem />
        <NumberSelector
          selectorLabel={t(translationKeys.SEARCH_FILTER_BY_DATE_TO) as keyof typeof translationKeys}
          minValue={minSelectedValue}
          maxValue={maxValue}
          step={step}
          currentValue={maxSelectedValue}
          handleValueChange={handleToChange}
          data-testid="number-range-select-max"
        />
      </NumbersRangeWrapperInner>
    </NumbersRangeWrapper>
  )
}

export default NumbersRangeSelect
